import { omit } from "lodash-es";
import { serviceURL } from "../../utils/service-url";
import { ApiService } from "./client";

import type { Workers } from "../../utils/service-url";
import type { ApiResponse } from "./client";

export abstract class WorkerApiService extends ApiService {
  abstract module: Workers;

  async request<T>(method: string, path: string, body?: unknown): Promise<ApiResponse<T>> {
    const response = await fetch(`${serviceURL(this.module)}${path}`, {
      method,
      body: body ? JSON.stringify(body) : null,
      headers: this.headers(),
    });
    const data: (T & { error: string }) | undefined = [204, 401, 403].includes(response.status)
      ? undefined
      : await response.json();

    if (!response.ok) {
      return {
        error: data?.error || "Unknown error",
        data: undefined,
        status: response.status,
      };
    }

    return {
      error: undefined,
      // oxlint-disable-next-line typescript/no-unsafe-type-assertion
      data: omit(data, "error") as T,
      status: response.status,
    };
  }
}
